import React from 'react'
import styled, { css } from 'styled-components'
import { string, bool, node, func } from 'prop-types'
import { stripUnit } from 'polished'

import { media } from 'styles/media'
import { black, white, borderColor } from 'styles/colors'
import { verticalPadding, square } from 'styles/global'
import { H3, fontSizes, fontWeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Wrapper from 'components/Wrapper'

const Container = styled.div`
  background-color: #fbfbfb;
  margin-bottom: 2.5rem;
  ${verticalPadding`2rem`};

  ${media.medium`
    margin-bottom: 3rem;
    ${verticalPadding`2.5rem`};
  `};

  ${media.large`
    ${verticalPadding`3rem`};
  `};
`

const Heading = styled(H3)`
  font-weight: ${fontWeights.regular};
  text-align: center;
  text-transform: uppercase;
  margin-bottom: ${spacing.medium};
  letter-spacing: 0.1em;
  margin-top: -${spacing.tiny};

  ${media.medium`
    margin-bottom: ${spacing.large};
    margin-top: -${spacing.small};
  `};

  ${media.large`
    margin-bottom: ${spacing.xLarge};
  `};
`

const Inner = styled.div`
  display: flex;
  justify-content: center;
`

const FilterContainer = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSizes.tiny};
  letter-spacing: 0.1em;
  font-size: 16px;
  color: ${black};
  border: 1px solid ${borderColor};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.07);
  text-align: center;
  padding: ${stripUnit(spacing.small) * 1.5 + 'px'};
  width: 130px;
  background-color: ${white};
  border-radius: 8px;

  ${media.small`
    width: 200px;
    font-size: 18px;
  `};

  ${media.medium`
    width: 280px;
    font-size: 20px;
    padding: ${spacing.medium};
  `};

  ${media.large`
    width: 340px;
    font-size: 24px;
  `};

  ${media.xLarge`
    width: 420px;
  `};

  ${props =>
    props.selected &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-shadow: inset 0 0 0 1px ${black}, 0 0 0 1px ${black};
        border-radius: 8px;
      }
    `}

  & + & {
    margin-left: ${spacing.medium};

    ${media.small`
      margin-left: ${spacing.large};
    `};

    ${media.medium`
      margin-left: ${spacing.xLarge};
    `};

    ${media.large`
      margin-left: ${spacing.xxxLarge};
    `};

    ${media.xLarge`
      margin-left: 80px;
    `};
  }
`

const FilterFigure = styled.img`
  flex-shrink: 0;
  margin-right: ${spacing.small};
  ${square('32px')};

  ${media.small`
    margin-right: ${stripUnit(spacing.small) * 1.5 + 'px'};
    ${square('40px')};
  `};

  ${media.medium`
    margin-right: ${spacing.medium};
    ${square('56px')};
  `};

  ${media.large`
    margin-right: ${spacing.large};
    ${square('64px')};
  `};

  ${media.xLarge`
    ${square('72px')};
  `};
`

const Filters = ({ children }) => (
  <Container>
    <Wrapper>
      <Heading>What's your device?</Heading>
      <Inner>{children}</Inner>
    </Wrapper>
  </Container>
)

export const Filter = ({ selected, title, onClick }) => (
  <FilterContainer selected={selected} onClick={onClick}>
    <FilterFigure src={`${process.env.BASE_PATH}/images/refills/icons/${title.toLowerCase()}.svg`} />
    {title}
  </FilterContainer>
)

Filter.propTypes = {
  selected: bool,
  title: string,
  onClick: func
}

Filters.propTypes = {
  children: node.isRequired
}

export default Filters
